import { render, staticRenderFns } from "./reportProficientRoomFee.vue?vue&type=template&id=13f63f2c&scoped=true"
import script from "./reportProficientRoomFee.vue?vue&type=script&lang=js"
export * from "./reportProficientRoomFee.vue?vue&type=script&lang=js"
import style0 from "./reportProficientRoomFee.vue?vue&type=style&index=0&id=13f63f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f63f2c",
  null
  
)

export default component.exports